import { useEffect } from 'react';

import { FormikProps } from 'formik';

import { adminPharmaciesInfo, convertToDecimals, getPharmaciesInfo } from '@pharmaplan/common';

import { useAppDispatch } from '../../useAppDispatch';
import { useAppSelector } from '../../useAppSelector';

const useExpressBookingHr = (formik: FormikProps<any>, id: string, pharmacyId:string) => {
  const dispatch = useAppDispatch();
  const isFromCalendar = !id;

  const pharmaciesInfo = useAppSelector(adminPharmaciesInfo);

  const { values, setFieldValue } = formik ?? {};
  const { pharmacies, pharmacySelected } = values ?? {};
  const { hourlyRate, pharmacyHourlyRate } = pharmaciesInfo ?? {};

  const handlePharmacyRate = () => {
    setFieldValue('pharmacyHourlyRate', convertToDecimals(pharmacyHourlyRate));
    setFieldValue('pharmacistHourlyRate', convertToDecimals(hourlyRate));
  };

  useEffect(() => {
    if (pharmacyId || formik.values.pharmacyId) {
      dispatch(getPharmaciesInfo({ id: pharmacyId || formik.values.pharmacyId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pharmacyId, formik.values.pharmacyId]);

  useEffect(() => {
    if (isFromCalendar) {
      handlePharmacyRate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hourlyRate, pharmacySelected]);

  useEffect(() => {
    if (!pharmacies.trim() && !pharmacySelected && isFromCalendar) {
      setFieldValue('pharmacyHourlyRate', '');
      setFieldValue('pharmacistHourlyRate', '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pharmacies, pharmacySelected]);
};

export default useExpressBookingHr;
